import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { GetSystemUserUser, GetSystemUserEnterprise } from "../../services/ReasonService";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { Alerts } from "../Alerts/Alerts";
import { useTranslation } from "react-i18next";
import { SystemUserStyles } from "./SystemUserStyles";
import { CommonStyles } from "../../commons/CommonStyles";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { DialogCreate } from "./components/DialogCreate";
// import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import { DialogSystemUserDelete } from "./components/DialogSystemUserDelete";
import { DialogChangeSecret } from "./components/DialogChangeSecret";
import { CorreosIcon } from "../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../commons/EnumsGeneral";

export function SystemUser(props) {
  const { idEnterprise, /*getIsOrganization,*/ getIsTitular } = props;
  const { t } = useTranslation();
  const classes = SystemUserStyles();
  const commonClasses = CommonStyles();

  const [openCreate, setOpenCreate] = useState(false);
  const [systemUserList, setSystemUserList] = useState([]);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [circularProgress, setCircularProgress] = useState(true);
  // const [isOrganization, setIsOrganization] = useState(false);
  const [isTitular, setIsTitular] = useState(false);

  useEffect(() => {
    setCircularProgress(true);
    // setIsOrganization(getIsOrganization());
    setIsTitular(getIsTitular());
    getSystemUsers();
  }, [idEnterprise]);

  const getSystemUsers = () => {
    let auxCall = checkIsNullUndefined(idEnterprise) ? GetSystemUserUser : GetSystemUserEnterprise;
    auxCall(idEnterprise).then((response) => {
      if (response && !response.Status) {
        setSystemUserList(response);
      } else {
        //Alerta
        finishOperation("error", getErrorMessage(response, t));
      }
      setCircularProgress(false);
    });
  };

  const isEvenRow = (index) => {
    return index % 2 == 0;
  };

  const addSystemUser = (systemUser) => {
    setSystemUserList([...systemUserList, systemUser]);
  };

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };
  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      {circularProgress ? <CircularProgress style={{ margin: "auto" }} /> : (
        <Grid>
          <Grid container spacing={0}>
            <Grid container item xs={12}>
              <Grid container item xs={12} className={classes.rgpdTitle}>
                <Grid item xs={12} md={6} style={{ display: "flex" }}>
                  <CorreosIcon iconSelected={iconNames.app} iconName="App Icon" iconState="basic" iconScale={3} />
                  {/* <SettingsApplicationsIcon className={classes.imgIcon} /> */}
                  <Typography className={classes.rgpdTitleText}>
                    {t("SystemUser")}
                  </Typography>
                </Grid>
              </Grid>
              {systemUserList.length < 1 ? (
                <Grid container item md={12} xs={12}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={classes.tycInfoHeader}
                  >
                    <Typography variant="h6" className={classes.titleColumn}>
                      {t("systemUserPageNoApps")}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Grid container item md={12} xs={12} style={{ marginBottom: "1em" }}>
                  <Grid item xs={5} className={classes.tycInfoHeader}>
                    <Typography variant="h6" className={classes.titleColumn}>
                      {t("systemUserPageName")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.tycInfoHeader2}>
                    <Typography variant="h6" className={classes.titleColumn}>
                      {t("systemUserPageClientId")}
                    </Typography>
                  </Grid>
                  <Grid item xs={1} className={classes.tycInfoHeader2}></Grid>
                </Grid>
              )}
              <Grid item md={12} xs={12}>
                {systemUserList.map((systemUser, index) => {
                  return (
                    <Grid
                      container
                      className={
                        !isEvenRow(index) ? classes.oddRow : classes.evenRow
                      }
                      key={index}
                    >
                      <Grid item xs={5} className={classes.tycsApps}>
                        <Typography>{systemUser.name} </Typography>
                      </Grid>
                      <Grid item xs={5} className={classes.tycsApps}>
                        <Typography>{systemUser.client_id}</Typography>
                      </Grid>
                      <Grid item xs={1} style={{ marginTop: "auto", marginBottom: "auto", textAlign: "right" }}>
                        <DialogChangeSecret systemUserData={systemUser} finishOperation={finishOperation} idEnterprise={idEnterprise} /*isOrganization={isOrganization}*/ isTitular={isTitular} />
                      </Grid>
                      <Grid item xs={1} style={{ marginTop: "auto", marginBottom: "auto", textAlign: "right" }}>
                        <DialogSystemUserDelete clientId={systemUser.client_id} idEnterprise={idEnterprise} refresh={getSystemUsers} finishOperation={finishOperation} /*isOrganization={isOrganization}*/ isTitular={isTitular} />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>

              <Grid
                item
                xs={12}
                className={commonClasses.gridIdentity}
                style={{ marginTop: "2em", marginRight: "1em" }}
              >
                <Grid item xs={12}>
                  <CorreosButton
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenCreate(true)}
                    style={{ float: "right" }}
                    disabled={systemUserList.length >= 3 || (/*isOrganization &&*/ !isTitular)}
                  >
                    {t("create")}
                  </CorreosButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <DialogCreate
        openCreate={openCreate}
        setOpenCreate={setOpenCreate}
        finishOperation={finishOperation}
        idEnterprise={idEnterprise}
        addSystemUser={addSystemUser}
        systemUserList={systemUserList}
      />
    </Grid>
  );
}
